const updateStudentGradesInAssessmentItems = ({
  studentGrades,
  updatedStudentGrade,
}) =>
  studentGrades && studentGrades.length
    ? studentGrades.map((studentGrade) => {
        if (studentGrade.studentId === updatedStudentGrade.studentId) {
          return updatedStudentGrade;
        }
        return studentGrade;
      })
    : [updatedStudentGrade];

export default updateStudentGradesInAssessmentItems;
